import { Platform } from '@angular/cdk/platform';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { TranslateModule } from '@ngx-translate/core';
import { NebulaDateModule } from '../nebula-date/nebula-date.module';
import { NebulaDateService } from '../nebula-date/nebula-date.service';
import { NebulaFormsModule } from '../nebula-forms/nebula-forms.module';
import { NebulaIconsModule } from '../nebula-icons/nebula-icons.module';
import { NebulaDatepickerHeaderComponent } from './nebula-datepicker-header.component';
import { NebulaNeverDirective } from './nebula-datepicker-never.directive';
import { NebulaDatepickerWrapperComponent } from './nebula-datepicker-wrapper.component';
import { NebulaDateAdapter } from './nebula-datepicker.adapter';
import { NebulaDatepickerComponent } from './nebula-datepicker.component';
import { NEBULA_DATEPICKER_FORMATS } from './nebula-datepicker.formats';

@NgModule({
  declarations: [
    NebulaDatepickerComponent,
    NebulaDatepickerWrapperComponent,
    NebulaDatepickerHeaderComponent,
    NebulaNeverDirective
  ],
  imports: [
    CommonModule,
    NebulaFormsModule,
    MatDatepickerModule,
    NebulaIconsModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    TranslateModule,
    NebulaDateModule
  ],
  exports: [
    NebulaDatepickerComponent,
    NebulaNeverDirective
  ],
  providers: [
    {
      provide: DateAdapter, useClass: NebulaDateAdapter, deps: [Platform, NebulaDateService, MAT_DATE_LOCALE]
    },
    { provide: MAT_DATE_FORMATS, useValue: NEBULA_DATEPICKER_FORMATS }
  ]
})
export class NebulaDatepickerModule { }
